import { render } from "./BenchmarkReport.vue?vue&type=template&id=74bab2b0&scoped=true"
import script from "./BenchmarkReport.vue?vue&type=script&lang=js"
export * from "./BenchmarkReport.vue?vue&type=script&lang=js"

import "./BenchmarkReport.vue?vue&type=style&index=0&id=74bab2b0&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bab2b0"]])

export default __exports__